<template>
    <form @submit.prevent="onSubmit" class="row">
        <AlertDismiss ref="alert" />
        <div class="form-group col-12 mb-3">
            <label for="justificacion">Justificación</label>
            <textarea v-model="justification" class="form-control" id="justificacion" rows="3"
                placeholder="Indique los fundamentos de la decisión"></textarea>
        </div>
        <div>

            <button @click.prevent="approve" class="btn btn-success" :disabled="disableForm">
                <b-spinner small v-show="isUploadingForm === true"></b-spinner>
                Aprobar
            </button>
            <button @click.prevent="reject" class="btn btn-danger ms-2" :disabled="disableForm">
                <b-spinner small v-show="isUploadingForm === false"></b-spinner>
                Rechazar
            </button>
        </div>
    </form>
</template>

<script>
import { mapActions } from 'vuex';
import { EventNames, InitPageSize } from '@/plugins/enums';
import AlertDismiss from '@/components/shared/Alert-dismiss.vue';

export default {
    name: 'DenounceResolve',

    components: {
        AlertDismiss
    },
    
    props: {
        denunciationId: String
    },

    data() {
        return {
            modalShow: false,

            justification: null,
            approved: null,

            isUploadingForm: null,
        }
    },

    computed: {
        disableForm() {
            return !this.justification || this.isUploadingForm;
        }
    },

    methods: {
        ...mapActions(["addDenounceResolution"]),

        async approve() {
            await this.onSubmit(true);
        },

        async reject() {
            await this.onSubmit(false);
        },

        async onSubmit(isApproved) {
            this.isUploadingForm = isApproved;

            let result = await this.addDenounceResolution({
                denunciationId: this.denunciationId,
                reason: this.justification,
                approved: isApproved
            })

            if (result.isError) {
                this.$refs.alert.showAlert(result.message, 'danger');
                this.isUploadingForm = null;
                return;
            }

            this.$eventBus.$emit(EventNames.ResolvedDenunciation, { page: 1, pageSize: InitPageSize.DenouncePageSize });
            this.modalShow = false;
            this.$emit('alert', {message: 'La decisión ha sido enviada correctamente', type: 'success'});
            this.$emit('close');

            this.justification = null;
            this.isUploadingForm = null;
        },
    }

}
</script>